module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "top-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-inline searchform",
    attrs: {
      "method": "get"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searching($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group input-group-sm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "歌曲名稱 / 作者",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searching
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline member-menu-login mb-0"
  }, [(!this.authorized) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "href": "#",
      "data-toggle": "modal",
      "data-target": "#loginpanel",
      "title": "會員登入"
    }
  }, [_vm._v("登入")]), _vm._v(" "), _c('div', {
    staticClass: "modal fade loginmodal loginmodal-vertical text-center",
    attrs: {
      "id": "loginpanel",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-md"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "fblogn"
  }, [_c('h6', {
    staticClass: "title title-loginform"
  }, [_vm._v("臉書登入")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-fb btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fblogin
    }
  }, [_vm._v("Facebook登入")])]), _vm._v(" "), _c('h6', {
    staticClass: "title title-loginform"
  }, [_vm._v("一般登入")]), _vm._v(" "), _c('form', {
    staticClass: "loginform",
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "accountbox",
      "placeholder": "帳號/email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "passwordbox",
      "placeholder": "密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登入")])])])])])])]) : _vm._e(), _vm._v(" "), (!this.authorized) ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "href": "/register",
      "title": "會員註冊"
    }
  }, [_vm._v("註冊")])]) : _vm._e(), _vm._v(" "), (this.authorized) ? _c('li', {
    staticClass: "list-inline-item member-menu-text dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "/",
      "id": "memberCenter",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(_vm._s(_vm.UserName))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "memberCenter"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/collection'
    }
  }, [_vm._v("會員收藏")])]), _vm._v("\n                          歡迎回來\n                          "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.userLogout
    }
  }, [_vm._v("登出")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar navbar-toggleable-sm navbar-light"
  }, [_vm._m(3), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand main-logo",
    attrs: {
      "href": '/'
    }
  }, [_c('span', [_vm._v("桅頂上")])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse main-menu",
    attrs: {
      "id": "navbarCollapse"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav mt-2"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/about'
    }
  }, [_vm._v("緣起 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/songsPick'
    }
  }, [_vm._v("挑歌秘笈")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "href": "/",
      "id": "navbarDropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("精選歌曲")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "navbarDropdownMenuLink"
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songsCatalog'
    }
  }, [_vm._v("分類說明")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/1'
    }
  }, [_vm._v("求婚/迎賓")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/2'
    }
  }, [_vm._v("新人進場")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/3'
    }
  }, [_vm._v("愛情故事回顧")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/4'
    }
  }, [_vm._v("婚宴配樂")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/songCategory/5'
    }
  }, [_vm._v("送客/蜜月")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": '/topic'
    }
  }, [_vm._v("特別企劃主題")])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": '/featured'
    }
  }, [_vm._v("頂上故事")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": '/hot'
    }
  }, [_vm._v("熱門話題")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/contact'
    }
  }, [_vm._v("聯絡我們")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-primary text-center",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("會員登入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock fa-lg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarCollapse",
      "aria-controls": "navbarCollapse",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39ee62dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Topbar.vue
// module id = 161
// module chunks = 1